import React from "react";

export default function GradientText({ children, className = "", as: Tag = "span" }) {
    return (
        <Tag className={`text-gradient ${className}`}>
            {children}
        </Tag>
    );
}
